import * as CHIEFDOM_TYPES from './actionTypes';
import {
  IFetchChiefdomListRequest,
  IFetchChiefdomListSuccess,
  IFetchChiefdomListFailure,
  IFetchChiefdomListSuccessPayload,
  IClearChiefdomList
} from './types';

export const fetchChiefdomListRequest = ({
  districtId,
  successCb,
  failureCb
}: Omit<IFetchChiefdomListRequest, 'type'>): IFetchChiefdomListRequest => ({
  type: CHIEFDOM_TYPES.FETCH_CHIEFDOM_LIST_REQUEST,
  districtId,
  successCb,
  failureCb
});

export const fetchChiefdomListSuccess = (payload: IFetchChiefdomListSuccessPayload): IFetchChiefdomListSuccess => ({
  type: CHIEFDOM_TYPES.FETCH_CHIEFDOM_LIST_SUCCESS,
  payload
});

export const fetchChiefdomListFailure = (error: Error): IFetchChiefdomListFailure => ({
  type: CHIEFDOM_TYPES.FETCH_CHIEFDOM_LIST_FAILURE,
  error
});

export const clearChiefdomList = (): IClearChiefdomList => ({
  type: CHIEFDOM_TYPES.CLEAR_CHIEFDOM_LIST
});
